export default __webpack_public_path__ + "static/Okay-Human-84819cd78bc5e8a099335def6d86fda0.png";